const initial = { data: [], loading: true };
const initialObject = { data: null, loading: true };

export const GetRegistryProjectRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registryproject":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistrySummaryRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registrysummary":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryVendorsRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registryvendors":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryVendorTypesRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registryvendortypes":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryChargeHeadsRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrychargeheads":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryChargeHeadTypesRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registrychargeheadtypes":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryStagesRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrystages":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryCasesRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrycases":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryEligibleSalesRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registryeligiblesales":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryReceiptsRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registryreceipts":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryReceiptPopulateRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registryreceiptpopulate":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryCaseChargeSummaryRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrycasechargesummary":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryPaymentsRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrypayments":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryPaymentPopulateRed = (state = initialObject, action) => {
  switch (action.type) {
    case "get_registrypaymentpopulate":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};

export const GetRegistryCaseChargeSpentRed = (state = initial, action) => {
  switch (action.type) {
    case "get_registrycasechargespent":
      return { data: action.payload, loading: action.loading };
    default:
      return state;
  }
};
